import React, { Fragment } from "react";
import { translate } from "../Services/translation";

const Navigation = ({ links = [], contentLink = null, level = 0 }) => {
  let menuRef = React.createRef();
  function toggleMenu() {
    menuRef.current.classList.toggle("navbar__menu--show");
  }
  const additionClass =
    contentLink && contentLink.attributes
      ? contentLink.attributes.cssValue
      : null;
  const selectedClass =
    contentLink && contentLink.isSelected ? "navbar__link--selected" : "";
  const hasChildrenClass = links.length > 0 ? "has-children" : null;
  const hasNameOrChildren = (link) =>
    link.name || (link.links || []).length > 0;
  const leftSide =
    level == 0 ? links.filter((x) => x.isRightAligned == false) : [];
  const rightSide =
    level == 0 ? links.filter((x) => x.isRightAligned == true) : [];
  level++;

  const navigateBack = () => {
    toggleMenu();
  };

  return (
    <Fragment>
      {!contentLink ? (
        <a
          className="navbar__link--block navbar__icon--menu navbar__icon"
          onClick={toggleMenu}
        ></a>
      ) : (
        <Fragment>
          <a
            className={`navbar__link navbar__link--desktop ${selectedClass} ${
              hasChildrenClass || ""
            } ${additionClass || ""}`}
            href={contentLink.url || "#"}
            dangerouslySetInnerHTML={{
              __html: "<span>" + contentLink.name + "</span>",
            }}
            onClick={!!links.length ? toggleMenu : undefined}
          ></a>
          <a
            className={`navbar__link navbar__link--mobile ${selectedClass} ${
              hasChildrenClass || ""
            } ${additionClass || ""}`}
            href={(!links.length && contentLink.url) || "#"}
            dangerouslySetInnerHTML={{
              __html: "<span>" + contentLink.name + "</span>",
            }}
            onClick={!!links.length ? toggleMenu : undefined}
          ></a>
          {links.length > 0 && (
            <i
              className="navbar__icon--caret-right navbar__icon navbar__icon--open"
              onClick={toggleMenu}
            ></i>
          )}
        </Fragment>
      )}

      {links.length > 0 && level == 2 ? (
        <div className="navbar__menu-container">
          <ul className="navbar__menu" ref={menuRef}>
            <li className="navbar__item navbar__item--back">
              <a
                className="navbar__link navbar__link--back"
                onClick={navigateBack}
              >
                <i className="navbar__icon--caret-left"></i>
                {translate("general.back")}
              </a>
            </li>
            {contentLink && contentLink.url && (
              <li className="navbar__item navbar__item--show-all">
                <a
                  className="navbar__link navbar__link--show-all"
                  href={contentLink.url}
                >
                  {translate("general.show-all")} {contentLink.name}
                </a>
              </li>
            )}
            {links.length > 0 &&
              links.map(
                (link, i) =>
                  hasNameOrChildren(link) && (
                    <li className="navbar__item" key={link.url}>
                      <Navigation
                        links={link.links}
                        contentLink={link}
                        level={level}
                      />
                    </li>
                  )
              )}
          </ul>
        </div>
      ) : links.length > 0 && level == 1 ? (
        <Fragment>
          <ul className="navbar__menu navbar__menu__top" ref={menuRef}>
            {leftSide.length > 0 &&
              leftSide.map(
                (link, i) =>
                  hasNameOrChildren(link) && (
                    <li className="navbar__item top-navbar-text" key={link.url}>
                      <Navigation
                        links={link.links}
                        contentLink={link}
                        level={level}
                      />
                    </li>
                  )
              )}
            {rightSide.length > 0 &&
              rightSide.map((link, i) =>
                hasNameOrChildren(link) && i == 0 ? (
                  <li
                    className="navbar__item top-navbar-text navbar__item--right first"
                    key={link.url}
                  >
                    <Navigation
                      links={link.links}
                      contentLink={link}
                      level={level}
                    />
                  </li>
                ) : (
                  <li
                    className="navbar__item top-navbar-text navbar__item--right"
                    key={link.url}
                  >
                    <Navigation
                      links={link.links}
                      contentLink={link}
                      level={level}
                    />
                  </li>
                )
              )}
          </ul>
        </Fragment>
      ) : (
        <ul className="navbar__menu" ref={menuRef}>
          <li className="navbar__item navbar__item--back">
            <a
              className="navbar__link navbar__link--back"
              onClick={navigateBack}
            >
              <i className="navbar__icon--caret-left"></i>
              {translate("general.back")}
            </a>
          </li>
          {contentLink && (
            <li className="navbar__item navbar__item--show-all">
              <a
                className="navbar__link navbar__link--show-all"
                href={contentLink.url}
              >
                {translate("general.show-all")} {contentLink.name}
              </a>
            </li>
          )}
          {links.length > 0 &&
            links.map(
              (link, i) =>
                hasNameOrChildren(link) && (
                  <li className="navbar__item" key={link.url}>
                    <Navigation
                      links={link.links}
                      contentLink={link}
                      level={level}
                    />
                  </li>
                )
            )}
        </ul>
      )}
    </Fragment>
  );
};

export default Navigation;
